<template>
  <div
    class="w-full mb-6 p-2"
    :class="{
      'group/programItem cursor-pointer transition hover:bg-(bg-subtle)': isDescriptionTruncated,
    }"
  >
    <div
      :class="[
        props.section.styles.textAlignment.value,
      ]"
      @click="isDescriptionTruncated ? isDialogOpen = true : ''"
    >
      <div class="text-(fg-subtle)">
        <template v-if="props.programItem.startTime !== props.programItem.endTime">
          {{ props.programItem.startTime }} - {{ props.programItem.endTime }}
        </template>
        <template v-else>
          {{ props.programItem.startTime }}
        </template>
      </div>
      <strong
        :class="{ 'transition group-hover/programItem:text-(fg-accent)': isDescriptionTruncated }"
        v-html="sanitize(props.programItem?.[props.section.lang.value]?.title)"
      />
      <div
        ref="descriptionRef"
        class="text-(fg-subtle) line-clamp-3"
        v-html="sanitize(props.programItem?.[props.section.lang.value]?.description)"
      />
      <div
        v-if="props.programItem.coverImage"
        class="flex"
        :class="[
          props.section.styles.textAlignment.value,
        ]"
      >
        <div
          class="overflow-hidden mt-2"
          :class="[
            props.section.styles.imageSize.value,
            props.section.styles.imageCrop.value,
            props.section.styles.cornerRadius.value,
            {
              'bg-(fg-muted)': !props.programItem.coverImage,
            },
          ]"
        >
          <img
            :src="`${useRuntimeConfig().public.imagekit}${useRuntimeConfig().public.imagekit ? '/tr:w-1140,c-at_max/' : ''}${props.programItem.coverImage}`"
            class="h-full object-cover"
            :alt="sanitize(props.programItem?.[props.section.lang.value]?.title)"
          >
        </div>
      </div>
    </div>
    <PageAgendaBasicItemDialog
      v-if="isDialogOpen"
      :program-item="props.programItem"
      :lang="props.section.lang.value"
      :event="props.event"
      @close="isDialogOpen = false"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  section: {
    type: Object,
    default: () => ({}),
  },
  event: {
    type: Object,
    default: () => ({}),
  },
  programItem: {
    type: Object,
    required: true,
  },
});

// Refs
const isDialogOpen = ref(false);

// Computed
const isDescriptionTruncated = useIsTruncated({
  elementRef: useTemplateRef('descriptionRef'),
  content: computed(() => props.programItem?.[props.section.lang.value]?.description),
});
</script>
